import { useQuery } from '@tanstack/react-query';

import { DrugsApi, type FetchDrugImagesParams } from '@/api/domains/drugs.api';
import { DrugsQueryKeys } from '@/api/domains/drugs.query-keys';
import type { DrugImage } from '@/api/domains/drugs.types';

type UseDrugImages = Partial<FetchDrugImagesParams>;

const defaultDrugImages = [] as DrugImage[];

export const useDrugImages = (params: UseDrugImages) =>
  useQuery({
    queryKey: DrugsQueryKeys.getImagesKey({ drug_id: params.drug_id }),
    queryFn: async () => {
      if (!params.drug_id) return defaultDrugImages;

      const { items } = await DrugsApi.fetchImages({ drug_id: params.drug_id });
      return items;
    },
    staleTime: Infinity,
  });
